import { useEffect, useState } from "react";
import HomeService from "../Services/Home";
import i18n, { _get_i18Lang } from "../i18n";
import CloseIcon from "../Images/close-C.png"
import { useNavigate } from "react-router-dom";

const FullImage = () => {
    const navigate = useNavigate();
    const [banners, setbanners] = useState(undefined);
    useEffect(() => {
        HomeService.getHomeData(_get_i18Lang(), "").then((res) => {
            if (res?.status) {
                setbanners(res.result?.banners[0]?.bannerPath);
            }
        });
    }, [i18n.language]);

    return (
        <div className="cursor-pointer">
            <div style={{ backgroundColor: "#000" }}
                onClick={() => {
                    navigate(-1 )
                }}
            >
                <img src={CloseIcon} alt="" style={{ float: "right", margin: " 10px 10px 0 0", width: "50px" }} />
            </div>
                <img src={banners} alt="Banner" width="100%" />
        </div>
    );
};

export default FullImage;
